import React, { use, useEffect, useRef, useState } from "react";
import { TextField, InputAdornment, Button, MenuItem } from "@mui/material";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import {
  FaNewspaper,
  FaExchangeAlt,
  FaTags,
  FaMapMarkedAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  getNewsBySlug,
  newsIconUpload,
  newsImageUpload,
  newsUpdate,
  resetNewsImage,
  SlugUrlExist,
  updateNewsSliderImages,
} from "../../redux/news/NewsSlice";
import { toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";
import { MdGTranslate } from "react-icons/md";
import { useParams } from "react-router-dom";
import { Modal } from "antd";
import {
  getWordCount,
  isContentWithinLimit,
  resolveExclusiveToggle,
  truncateToWordLimit,
} from "../../utils/newsValidation";

const states = ["Andhra Pradesh", "Telangana"];

const AddNews = () => {
  const dispatch = useDispatch();
  const { updatenews, newsSlider, newsicon, newsthumb } = useSelector(
    (state) => state.newsAdmin
  );
  const params = useParams();
  let catUrl = params.newsurl;
  
  useEffect(() => {
    if (catUrl) {
      dispatch(getNewsBySlug(catUrl));
    }
  }, [dispatch, catUrl]);
  
  const { allCategorys } = useSelector((store) => store.category);
  const { data, mandals } = useSelector((state) => state.districts);
  const stateData = data[0];
  const [categroyId, setCategroyId] = useState("");
  const [titleTelugu, setTitleTelugu] = useState("");
  const [titleEnglish, setTitleEnglish] = useState("");
  const [contentTelugu, setContentTelugu] = useState("");
  const [contentEnglish, setContentEnglish] = useState("");
  const [category, setCategory] = useState("");
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [mandal, setMandal] = useState("");
  const [sliderShow, setSliderShow] = useState(false);
  const [breakingNews, setBreakingNews] = useState(false);
  const [metaKeywords, setMetaKeywords] = useState("");
  const admin = JSON.parse(localStorage.getItem("admin"));

  const normalizeMetaKeywords = (value) =>
    String(value ?? "")
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  const [checkslugUrl, setCheckSlugUrl] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [file, setFile] = useState(newsicon);
  const [showPopup, setShowPopup] = useState(false);
  const [originalFile, setOriginalFile] = useState(newsicon);
  const [village, setVillage] = useState("");
  const [villageEng, setVillageEng] = useState("");
  const [mandalInTelugu, setMandalInTelugu] = useState("");
  const cropperRef = useRef(null);
  const [districtInTelugu, setDistrictInTelugu] = useState(false);

  useEffect(() => {
    if (!updatenews || !updatenews.slugUrl) {
      setTitleTelugu("");
      setTitleEnglish("");
      setContentTelugu("");
      setContentEnglish("");
      setCategroyId("");
      setCategory("");
      setState("");
      setDistrict("");
      setMandal("");
      setVillage("");
      setVillageEng("");
      setSliderShow(false);
      setBreakingNews(false);
      setMetaKeywords("");
      setOriginalFile(null);
      setFile(null);
      return;
    }

    setTitleTelugu(updatenews.newsTitleInTelugu || "");
    setTitleEnglish(updatenews.newsTitleInEnglish || "");
    setContentTelugu(updatenews.newsContentInTelugu || "");
    setContentEnglish(updatenews.newsContentInEnglish || "");
    setCategroyId(updatenews.categoryId || "");
    setCategory(updatenews.category || "");
    setState(updatenews.state || "");
    setDistrict(updatenews.district || "");
    setMandal(updatenews.mandal || "");
    setVillage(updatenews.villageTelugu || "");
    setVillageEng(updatenews.village || "");
    setSliderShow(Boolean(updatenews.sliderShow));
    setBreakingNews(Boolean(updatenews.breakingNewsShow));
    setMetaKeywords(updatenews.metaKeywords || "");
    setOriginalFile(updatenews.icon || null);
    setFile(updatenews.icon || null);
  }, [updatenews]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFile(URL.createObjectURL(file));
      setOriginalFile(file);
    }
  };

  const handleCrop = () => {
    const cropper = cropperRef.current?.cropper;
    const croppedCanvas = cropper.getCroppedCanvas();
    if (croppedCanvas) {
      const croppedImageUrl = croppedCanvas.toDataURL("image/jpeg");
      setFile(croppedImageUrl);
      setShowPopup(false);
      dispatch(newsIconUpload({ slider: croppedImageUrl }));
    }
  };

  const handleReCrop = () => {
    if (originalFile) {
      setFile(URL.createObjectURL(originalFile));
      setShowPopup(true);
    }
  };



  const thumbnailChange = (e) => {
    const files = Array.from(e.target.files);

    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          dispatch(newsImageUpload({ slider: reader.result }));
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const imageRemoveClick = (e, imagename) => {
    let imagearray = newsSlider;
    imagearray = imagearray.filter((image) => image !== imagename);
    dispatch(updateNewsSliderImages(imagearray));
  };

  const translateAllFields = async () => {
    const translateText = async (text, sourceLang, targetLang) => {
      if (!text) return "";
      const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=${sourceLang}&tl=${targetLang}&dt=t&q=${encodeURIComponent(
        text
      )}`;
      try {
        const response = await fetch(url);
        const data = await response.json();
        return data[0][0][0] || text;
      } catch (error) {
        console.error("Translation error", error);
        return text;
      }
    };

    const sourceText = titleTelugu || titleEnglish || contentTelugu || contentEnglish || village || villageEng;
    const isTelugu = /[\u0C00-\u0C7F]/.test(sourceText);
    const sourceLang = isTelugu ? "te" : "en";
    const targetLang = isTelugu ? "en" : "te";

    const [translatedTitle, translatedContent, translatedMandal] =
      await Promise.all([
        translateText(titleTelugu || titleEnglish || "", sourceLang, targetLang),
        translateText(contentTelugu || contentEnglish || "", sourceLang, targetLang),
        translateText(village || villageEng || "", sourceLang, targetLang),
      ]);

    if (sourceLang === "en") {
      setTitleTelugu(translatedTitle);
      setContentTelugu(translatedContent);
      setVillage(translatedMandal);
    } else {
      setTitleEnglish(translatedTitle);
      setContentEnglish(translatedContent);
      setVillageEng(translatedMandal);
    }
  };

  const mandalsData = mandals
    .filter((item) => item.districts.english === district)
    .map((item) => item.mandal);

  useEffect(() => {
    if (titleEnglish) {
      const slug = titleEnglish
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "")
        .replace(/-{2,}/g, "-")
        .replace(/^-+|-+$/g, "");
      setCheckSlugUrl(slug);
    }
  }, [titleEnglish]);

  const handleToggleValue = (type) => {
    const nextState = resolveExclusiveToggle(type, sliderShow, breakingNews);
    setSliderShow(nextState.slider);
    setBreakingNews(nextState.breaking);
  };

  const englishWordLimitOk = isContentWithinLimit(contentEnglish);
  const teluguWordLimitOk = isContentWithinLimit(contentTelugu);

  const handleWordLimitedContent = (setter, value) => {
    const nextValue = truncateToWordLimit(value);
    setter(nextValue);

    if (getWordCount(value) > 50) {
      toast.warn("Maximum 50 words allowed in each language.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      checkslugUrl !== "" &&
      contentEnglish !== "" &&
      contentTelugu !== "" &&
      titleTelugu !== "" &&
      titleEnglish !== "" &&
      englishWordLimitOk &&
      teluguWordLimitOk
    ) {
      const payload = {
        _id: updatenews?._id,
        categoryId: categroyId,
        category: category,
        newsTitleInEnglish: titleEnglish,
        newsTitleInTelugu: titleTelugu,
        slugUrl: updatenews?.slugUrl || checkslugUrl,
        newsContentInEnglish: contentEnglish,
        newsContentInTelugu: contentTelugu,
        state: state,
        stateTelugu: state === "Telangana" ? "తెలంగాణ" : "ఆంధ్ర ప్రదేశ్",
        district: district,
        mandal: mandal,
        mandalTelugu: mandalInTelugu,
        village: villageEng,
        villageTelugu: village,
        breakingNewsShow: breakingNews,
        sliderShow: sliderShow,
        metaKeywords: normalizeMetaKeywords(metaKeywords),
        slider: newsSlider,
        thumbnail: newsthumb,
        icon: newsicon,
        newsAprovelText: "Draft",
        reporterId: admin.id,
        reporterName: admin.name,
        email: admin.email,
      };

      const response = await dispatch(newsUpdate(payload));
      if (response.payload.success) {
        await dispatch(resetNewsImage());
        toast.success("News article submitted successfully as draft!");
        window.history.back();
      } else {
        toast.error("Failed to submit news article.");
      }
    } else {
      toast.warn(
        !englishWordLimitOk || !teluguWordLimitOk
          ? "News content should not exceed 50 words in each language."
          : "Please fill all required fields correctly."
      );
    }
  };

  return (
    <>
      <div className="main_fragnent_container p-2">
        <div className="profile_container_header">
          <div className="profile_co_header_left">
            <span>Add News</span>
            <span
              style={{
                visibility: "hidden",
              }}
            >
              Student
            </span>
          </div>
          <div className="profile_co_header_right"></div>
        </div>
        <div className="main_recha_container">
          <div className="inputs_container">
            <div className="dn_input_box">
              <TextField
                id="select"
                label="Select category"
                select
                className="input_style"
                value={categroyId}
                onChange={(e) => {
                  const selected = allCategorys.find(
                    (cat) => cat._id === e.target.value
                  );
                  setCategroyId(e.target.value);
                  setCategory(selected?.nameInTelugu);
                }}
                size="small"
              >
                {allCategorys &&
                  allCategorys.map((data, index) => (
                    <MenuItem key={index} value={data._id}>
                      {data.nameInTelugu} ({data.nameInEnglish})
                    </MenuItem>
                  ))}
              </TextField>
            </div>
            <div className="dn_input_box">
              <TextField
                label="News Title Telugu"
                multiline
                rows={1}
                variant="outlined"
                id="text"
                className="input_style"
                autoComplete="off"
                size="small"
                fullWidth
                contentEditable={false}
                value={titleTelugu}
                onChange={(e) => setTitleTelugu(e.target.value)}
              />
            </div>
            <div className="dn_input_box">
              <TextField
                label={
                  checkslugUrl === "error"
                    ? "Category Already Exists"
                    : "Category Name In English"
                }
                multiline
                rows={1}
                variant="outlined"
                id="text"
                className="input_style"
                autoComplete="off"
                size="small"
                error={checkslugUrl === "error"}
                fullWidth
                value={titleEnglish}
                onChange={(e) => setTitleEnglish(e.target.value)}
              />
            </div>
            <div className="dn_input_box">
              <TextField
                label="News Content (Telugu)"
                multiline
                rows={8}
                variant="outlined"
                id="text"
                className="input_style"
                error={!teluguWordLimitOk}
                helperText={
                  !teluguWordLimitOk
                    ? `Telugu content exceeds the ${50} word limit (current: ${getWordCount(contentTelugu)}).`
                    : ""
                }
                value={contentTelugu}
                onChange={(e) => handleWordLimitedContent(setContentTelugu, e.target.value)}
                autoComplete="off"
                size="small"
                fullWidth
              />
            </div>
            <div className="dn_input_box">
              <TextField
                label="News Content (English)"
                multiline
                rows={8}
                variant="outlined"
                id="text"
                className="input_style"
                error={!englishWordLimitOk}
                helperText={
                  !englishWordLimitOk
                    ? `English content exceeds the ${50} word limit (current: ${getWordCount(contentEnglish)}).`
                    : ""
                }
                value={contentEnglish}
                onChange={(e) => handleWordLimitedContent(setContentEnglish, e.target.value)}
                autoComplete="off"
                size="small"
                fullWidth
              />
            </div>
            <div className="dn_input_box">
              <TextField
                label="News Keywords"
                multiline
                rows={3} // Adjust rows as needed
                variant="outlined"
                id="text"
                className="input_style"
                value={metaKeywords}
                onChange={(e) => setMetaKeywords(e.target.value)}
                autoComplete="off"
                size="small"
                fullWidth
              />
            </div>
            <div className="dn_input_box">
              <div className="translate_container">
                <button className="translate_btn" onClick={translateAllFields}>
                  <MdGTranslate className="translate_icon" />
                  <span className="translate_text">Click to Translate</span>
                </button>
              </div>
            </div>
            <div className="dn_input_box">
              <TextField
                id="select-state"
                label="Select State"
                select
                className="input_style"
                value={state}
                onChange={(e) => setState(e.target.value)}
                size="small"
              >
                {states.map((state) => (
                  <MenuItem key={state} value={state}>
                    {state === "Telangana" ? "Telangana (తెలంగాణ)" : ""}
                    {state === "Andhra Pradesh"
                      ? "Andhra Pradesh (ఆంధ్ర ప్రదేశ్)"
                      : ""}
                  </MenuItem>
                ))}
              </TextField>
            </div>

            {stateData && (
              <div className="dn_input_box">
                <TextField
                  id="select-district"
                  label="Select District"
                  select
                  className="input_style"
                  value={district}
                  onChange={(e) => setDistrict(e.target.value)}
                  size="small"
                >
                  {stateData[state]?.map((district, index) => (
                    <MenuItem key={index} onClick={() => setDistrictInTelugu(district.telugu)} value={district.english}>
                      {district.english} ({district.telugu})
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            )}

            <div className="dn_input_box">
              <TextField
                label="Mandal"
                id="Mandal"
                select
                name="mandal"
                className="input_style"
                value={mandal}
                onChange={(e) => setMandal(e.target.value)}
                variant="outlined"
                size="small"
              >
                {mandalsData.map((mandal, index) => (
                  <MenuItem
                    key={index}
                    value={mandal.english}
                    onClick={() => setMandalInTelugu(mandal.telugu)}
                  >
                    {mandal.english} ({mandal.telugu})
                  </MenuItem>
                ))}
              </TextField>
            </div>

            <div className="dn_input_box">
              <TextField
                label="Village (Telugu)"
                name="Village"
                variant="outlined"
                id="text"
                className="input_style"
                autoComplete="off"
                size="small"
                fullWidth
                contentEditable={false}
                value={village}
                onChange={(e) => setVillage(e.target.value)}
              />
            </div>
            <div className="dn_input_box">
              <TextField
                label="Village (English)"
                name="Village"
                variant="outlined"
                id="text"
                className="input_style"
                autoComplete="off"
                size="small"
                fullWidth
                contentEditable={false}
                value={villageEng}
                onChange={(e) => setVillageEng(e.target.value)}
              />
            </div>
            <div className="dn_input_box_new">
              <div className="input_style">
                <h6>Set Breaking News</h6>
                <div className="checkbox-wrapper-6">
                  <input
                    className="tgl tgl-light"
                    id="cb1-1"
                    type="checkbox"
                    checked={breakingNews}
                    onClick={() => handleToggleValue("breaking")}
                  />
                  <label className="tgl-btn" htmlFor="cb1-1"></label>
                </div>
              </div>
            </div>
            <div className="dn_input_box_new">
              <div className="input_style">
                <h6>Set Slider</h6>
                <div className="checkbox-wrapper-6">
                  <input
                    className="tgl tgl-light"
                    id="cb1-6"
                    type="checkbox"
                    checked={sliderShow}
                    onClick={() => handleToggleValue("slider")}
                  />
                  <label className="tgl-btn" htmlFor="cb1-6"></label>
                </div>
              </div>
            </div>
            <div className="dn_input_box">
              <div className="input_style">
                <h6>News Image</h6>

                <input
                  type="file"
                  id="img"
                  name="img"
                  accept="image/*"
                  onChange={thumbnailChange}
                  multiple
                  style={
                    newsSlider.length === 0
                      ? {
                          border: "1px solid red",
                          width: "100%",
                          background: "#ffe6e6",
                          cursor: "pointer",
                        }
                      : {
                          cursor: "pointer",
                        }
                  }
                />

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  {newsSlider.map((image, index) => (
                    <div
                      style={{
                        position: "relative",
                        height: "100px",
                        width: "150px",
                        margin: "5px",
                      }}
                      key={index}
                    >
                      <img src={image} height="100%" alt="img" />
                      <span
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 3,
                        }}
                        onClick={(e) => imageRemoveClick(e, image, index)}
                      >
                        <h6
                          style={{
                            fontWeight: "bold",
                            color: "red",
                            cursor: "pointer",
                            fontSize: "20px",
                          }}
                        >
                          X
                        </h6>
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="dn_input_box">
              <div className="az-container">
                <h2 className="az-title">Upload Image for Mobile</h2>
                <label className="az-upload-label">
                  <span>Choose Image</span>
                  <input
                    type="file"
                    className="az-hidden-input"
                    onChange={handleFileChange}
                  />
                </label>
                {file && (
                  <div className="az-preview-container">
                    <img
                      src={file}
                      alt="Original"
                      className="az-preview-image"
                      onClick={handleReCrop}
                    />
                    {showPopup && (
                      <div className="az-popup-overlay">
                        <div className="az-popup-content">
                          <Cropper
                            src={file}
                            style={{ height: 300, width: "100%" }}
                            initialAspectRatio={1}
                            aspectRatio={1}
                            guides={false}
                            ref={cropperRef}
                            className="az-cropper-style"
                          />
                          <button
                            onClick={handleCrop}
                            className="az-crop-button"
                          >
                            Crop Image
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="dn_input_box"></div>
            <div className="dn_input_box"></div>
            <div className="button_container">
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setPreviewOpen(true)}
                style={{ marginRight: 12 }}
              >
                Preview
              </Button>
              <LoadingButton onClick={handleSubmit} variant="contained" color="primary">
                Update News
              </LoadingButton>
            </div>
            <Modal
              title="News Preview"
              open={previewOpen}
              onCancel={() => setPreviewOpen(false)}
              footer={null}
            >
              <div>
                <h4>{titleEnglish || "Untitled News"}</h4>
                <p>
                  <strong>Telugu:</strong> {titleTelugu || "-"}
                </p>
                <p>
                  <strong>Views:</strong> {updatenews?.numberofViews ?? updatenews?.views ?? updatenews?.viewCount ?? 0}
                </p>
                <div>
                  <strong>Content (English):</strong>
                  <p>{contentEnglish || "-"}</p>
                </div>
                <div>
                  <strong>Content (Telugu):</strong>
                  <p>{contentTelugu || "-"}</p>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddNews;
